import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessageLines } from '@fortawesome/pro-regular-svg-icons';
import { Badge } from '@e2n/ui';

export function BemerkungCell({ bemerkung }: { bemerkung: string }) {
  return (
    <Badge className="px-1 py-1.5 bg-neutrals-200" variant="secondary">
      <FontAwesomeIcon
        icon={faMessageLines}
        size="xl"
        className={bemerkung ? 'text-primary-blue-600' : 'text-neutrals-600'}
      />
    </Badge>
  );
}
